import { render, staticRenderFns } from "./CashbackAndPointsTable.vue?vue&type=template&id=33a1c15c&scoped=true"
import script from "./CashbackAndPointsTable.vue?vue&type=script&lang=js"
export * from "./CashbackAndPointsTable.vue?vue&type=script&lang=js"
import style0 from "./CashbackAndPointsTable.vue?vue&type=style&index=0&id=33a1c15c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a1c15c",
  null
  
)

export default component.exports